import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, setAutoHeightByQuery, setMaxHeightByQuery } from "src/libs/utilities"
import { ALIGN, ICard, ILandingSection, InfoGraphiscContent, SECTION_PROPORTION_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import Dummy from "./Dummy"
import InfoGraphiscPrimitive from "../primitive/InfoGraphiscPrimitive"
import Card from "./cards/Card"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import DataContentEditor from "../landing-edit/editors/data-content-editor"

/* Protopia Ecosystem component */
export interface IInfoGraphicsProps {
    section: ILandingSection
    data:  InfoGraphiscContent 
}
const InfoGraphics = ({data, ...props}: IInfoGraphicsProps): JSX.Element => { 
    const alignFields = () => {
        if(data.vertical_align === ALIGN.START) {
            return
        }
        if(sizes.width > WINDOW_WIDTH.TABLET) {
            data.card_fields.forEach((field: any, i: number) => {
                setMaxHeightByQuery( `.landing-info-graphics-${data.id} .landing-card-body [data-card-field-id="${i}"]` );
                setMaxHeightByQuery( `.landing-info-graphics-${data.id} .landing-card-body [data-card-field-id="${i}"] .speech-bubble-content`);
            })
        }
        else {
            data.card_fields.forEach((field: any, i: number) => {
                setAutoHeightByQuery( `.landing-info-graphics-${data.id} .landing-card-body [data-card-field-id="${i}"]` );
                setAutoHeightByQuery( `.landing-info-graphics-${data.id} .landing-card-body [data-card-field-id="${i}"] .speech-bubble-content`);
            })
        }
    }
    const sizes             = useScreenSize()
    const cards: ICard[]    = data.cards as ICard[]
    const {position}          = usePosition(data)
    const [marginLeft]      = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]     = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]       = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]    = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [alignItems]      = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "center" : "flex-start")
    const [justify]         = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "center" : "flex-start")
    const [height, setHeight] = useState<string>(getCssDemention( position.height || data.height, "fit-content" ))

    useEffect(() => {
        addCSSClass(
            `landing-info-graphics-${data.id}`,
            `.landing-info-graphics-${data.id} {
                display: flex;
                align-items: ${alignItems};
                justify-content: ${justify};
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};                
                max-height: ${ height }; 
                height: ${ height };
                z-index:1;
                --dot-radius: ${ data.dotSize }px;
            } 
            `
        )
        alignFields()           
        return () => {
            removeCSSClass(`landing-info-graphics-${data.id}`)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]) 
    
    return !!data.cards?.length 
        ?
        <div className={`landing-content-container landing-info-graphics-${data.id} ${ data.className || "" } `} style={ data.style || {} }  data-type={data.type} data-content-id={data.id}>
            <div 
                role="article" 
                className={` landing-info-graphics info-graphics-${ data.id }`}
                style={ data?.style }
            >       
                <div className="left-cards flex-centered flex-column flex-wrap">
                    {
                        Array.isArray(cards) && cards
                        .filter((card, i) => { 
                            return i % 2 === 0
                        })
                        .map((card: ICard, i: number) =>  { 
                            return <Card
                                key={ card.id }
                                data={ { ...card, i, } }
                                contentData={ { ...data, }}
                                section={ props.section }
                                column={ 1 }
                            />
                        })
                    }
                </div>
                <InfoGraphiscPrimitive
                    primitive={ { 
                        ...( data ), 
                    } as any }
                />
                <div className="right-cards flex-centered flex-column  flex-wrap">
                    {
                        Array.isArray(cards) && cards
                        .filter((card, i) => { 
                            return i % 2 === 1
                        })
                        .map((card: ICard, i: number) =>  { 
                            return <Card
                                key={ card.id }
                                data={ { ...card, i } }
                                contentData={ { ...data, } }
                                section={ props.section }
                                column={ 1 }
                            />
                        })
                    }
                </div>
            </div>
            <DataContentEditor data={data} section={props.section} />
        </div>
        :
        <Dummy {...{ 
            data: {...data, className: `landing-info-graphics-${data.id}`}, 
            ...props 
        }} /> 
}
export default InfoGraphics